import React from 'react';

import { cssMap } from '@atlaskit/css';

export type AgentAvatarSize = 'small' | 'medium';

export const AGENT_AVATAR_SHELL_SIZE: Record<AgentAvatarSize, { width: number; height: number }> = {
	small: { width: 24, height: 27 },
	medium: { width: 32, height: 35 },
};

// Keep the standard avatar shell shape as the shared outer outline for all Presence agent types.
export const AGENT_AVATAR_SHELL_PATH: Record<AgentAvatarSize, string> = {
	small:
		'M 10.039 1.1031 A 4 4 0 0 1 13.961 1.1031 L 21.961 5.6031 A 4 4 0 0 1 24 9.0894 L 24 17.9106 A 4 4 0 0 1 21.961 21.3969 L 13.961 25.8969 A 4 4 0 0 1 10.039 25.8969 L 2.039 21.3969 A 4 4 0 0 1 0 17.9106 L 0 9.0894 A 4 4 0 0 1 2.039 5.6031 Z',
	medium:
		'M 13.33 1.46 A 5 5 0 0 1 18.67 1.46 L 29.34 7.29 A 5 5 0 0 1 32 11.66 L 32 23.34 A 5 5 0 0 1 29.34 27.71 L 18.67 33.54 A 5 5 0 0 1 13.33 33.54 L 2.66 27.71 A 5 5 0 0 1 0 23.34 L 0 11.66 A 5 5 0 0 1 2.66 7.29 Z',
};

const OUTLINE_WIDTH = 2;

const styles = cssMap({
	root: {
		position: 'absolute',
		left: '50%',
		transform: 'translateX(-50%)',
		pointerEvents: 'none',
		zIndex: 0,
	},
});

export const AgentPresenceOutline = ({
	color,
	size,
	testId = 'agent-presence-outline',
}: {
	color: string;
	size: AgentAvatarSize;
	testId?: string;
}): React.JSX.Element => {
	const { width, height } = AGENT_AVATAR_SHELL_SIZE[size];

	return (
		<span
			css={styles.root}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Preserves the exact fractional offset of the shared avatar shell.
			style={{ top: '0.2px' }}
			data-testid={testId}
			aria-hidden="true"
		>
			<svg
				display="block"
				width={width}
				height={height}
				viewBox={`0 0 ${width} ${height}`}
				overflow="visible"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				focusable="false"
			>
				<path
					d={AGENT_AVATAR_SHELL_PATH[size]}
					fill={color}
					stroke={color}
					strokeWidth={OUTLINE_WIDTH * 2}
				/>
			</svg>
		</span>
	);
};
